<template>
  <LazyBlogPageLayout hydrate-on-idle path="policy" />
</template>
<script setup lang="ts"></script>
